<template>
<div id="consulta_adjuntos_pedimentos">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container grid-list-md text-xs-center>

        <v-flex xs12>
            <base-material-card color="primary" icon="library_books" title="Reporte Pedimentos - UUID" class="elevation-1 px-5 py-3">
                <br />

                        <v-card-text>
                            <v-card-title>
                                <span class="headline"></span>
                            </v-card-title>
                            <v-form ref="formreporte" lazy-validation>
                                <v-container grid-list-md text-xs-center>

                                    <v-row row wrap>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="
                                                                        model.fecha_de = parseDate(model.fecha_de)
                                                                        " v-mask="'####-##-##'" :rules="[
                                                                        rules.required,
                                                                        validaDias,
                                                                        validaFecha,
                                                                        $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)
                                                                        ]">
                                                    </v-text-field>
                                                </template>

                                                <v-date-picker v-model="model.fecha_de" color="secondary" landscape scrollable locale="es-mx" @input="menu3 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu3 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[
                                                            rules.required,
                                                            validaDias,
                                                            validaFecha,
                                                            $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)
                                                            ]"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="model.fecha_a" color="secondary" landscape scrollable locale="es-mx" @input="menu4 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu4 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                         <v-col sm="12" md="2" lg="2">
                                          <v-switch
                                            v-model="fecha_factura"
                                            color="red darken-3"
                                            label="Fecha de Emisión"
                                        ></v-switch>
                                          </v-col>
                                         <v-col sm="12" md="2" lg="2">
                                          <v-btn rounded color="secondary" @click="generar_reporte_sqs()" :loading="loadingReporte">
                                                <v-icon>done</v-icon>Generar Reporte
                                            </v-btn>
                                          </v-col>
                                    </v-row>

                                </v-container>
                            </v-form>

                            <v-card>
                                <v-card-text>

                                    <v-refresh-button :funcion="cargarReportesDS" />
                                    <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                        <template slot="noResults" >
                                            <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                        </template>

                                        <template slot="actions" slot-scope="props" >
                                            <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadReporte(props.row.filename)" >
                                                <v-icon dark>get_app</v-icon>
                                            </v-btn>
                                            <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                                                <v-icon dark>delete</v-icon>
                                            </v-btn>
                                        </template>
                                    </v-client-table>
                                </v-card-text>
                            </v-card>
                        </v-card-text>


            </base-material-card>
        </v-flex>

    </v-container>
    <v-dialog v-model="dialog1" max-width="500px">
        <v-card>
            <v-card-text>
                <h5>Ingrese lista de ordenes de compra</h5>
                <span>Uno por línea</span>
                <v-form ref="formListado" lazy-validation="">
                    <v-textarea outlined rows="15" v-model="model.lista" :rules="[rules.required]"></v-textarea>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small @click="model.lista='';dialog1 = false">Cancelar</v-btn>
                <v-btn small color="primary" @click="setListValues();">Buscar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- Modal Factura Proforma -->
    <v-dialog v-model="modalProforma" width="65%" max-width="100%">
        <v-card>
            <v-card-title>
                <v-spacer></v-spacer>
                <v-card class="primary white--text titulomodal">
                    <v-icon class="white--text">receipt</v-icon>&nbsp;Factura Proforma
                </v-card>
            </v-card-title>

            <v-divider></v-divider>
            <v-card-text>

                    <v-container grid-list-md >
                        <v-layout wrap>
                            <v-flex xs12>
                                <div id="facturaProforma">
                                    <div style="text-align:center;font-size:12px;font-weight:bold;line-height:12px!important;">
                                        <span></span>
                                    </div><br>
                                    <div style="font-size:11px;">
                                        <table id="tablaGenerales" width="100%">
                                            <tr>
                                                <td width="49%">
                                                    <table>
                                                        <tr>
                                                            <th width="30%">RFC emisor:</th>
                                                            <td width="70%">{{model_proforma.RFC}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Nombre emisor:</th>
                                                            <td>{{model_proforma.Nombre}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Folio:</th>
                                                            <td>{{model_proforma.Folio}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>RFC receptor:</th>
                                                            <td>{{model_proforma[" RFC"]}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Nombre receptor:</th>
                                                            <td>{{model_proforma[" Nombre"]}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Uso CFDI:</th>
                                                            <td>{{model_proforma.UsoCFDI}}</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="2%"></td>
                                                <td width="49%">
                                                    <tr>
                                                        <th width="35%">Folio fiscal:</th>
                                                        <td width="65%">{{model_proforma["Folio Fiscal"]}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>No. de serie del CSD:</th>
                                                        <td>{{model_proforma["No Certificado"]}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Código postal, fecha y hora de emisión:</th>
                                                        <td>{{model_proforma["Lugar de Expedicion"]}} {{model_proforma["Fecha"]}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Efecto de comprobante:</th>
                                                        <td>{{model_proforma["Tipo de Comprobante"]}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Régimen fiscal:</th>
                                                        <td>{{model_proforma["Regimen Fiscal"]}}</td>
                                                    </tr>
                                                </td>
                                            </tr>
                                        </table>
                                        <br/>
                                        <span style="font-weight:bold;font-size:12px;">Conceptos</span>
                                        <br><br>
                                        <table id="tablaMercancias" border=1>
                                            <tr style="text-align:center;background-color:#DCDBDA;">
                                                <th width="10%">Clave del producto y/o servicio</th>
                                                <th width="10%">No. identificación</th>
                                                <th width="9%">Cantidad</th>
                                                <th width="8%">Clave de unidad</th>
                                                <th width="10%">Unidad</th>
                                                <th width="10%">Valor unitario</th>
                                                <th width="10%">Importe</th>
                                                <th width="10%">Descuento</th>
                                                <th width="11%">No. de pedimento</th>
                                                <th width="11%">No. de cuenta predial</th>
                                            </tr>
                                            <template v-for="(concepto) in model_proforma.conceptos">
                                                <tr>
                                                    <td>{{concepto["Clave Prod Serv"]}}</td>
                                                    <td>{{concepto["No Identificacion"]}}</td>
                                                    <td>{{formatNumber(concepto["Cantidad"],2)}}</td>
                                                    <td>{{concepto["Clave Unidad"]}}</td>
                                                    <td>{{concepto["Unidad"]}}</td>
                                                    <td>{{formatNumber(concepto["Valor Unitario"],2)}}</td>
                                                    <td>{{formatNumber(concepto["Subtotal"],2)}}</td>
                                                    <td></td>
                                                    <td>{{concepto["Pedimento"]}}</td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <th style="text-align:center;background-color:#DCDBDA;">Descripción</th>
                                                    <td colspan=4 style="vertical-align:middle !important; text-align:left !important;">{{concepto["Descripcion"]}}</td>
                                                    <td colspan=5>
                                                        <table id="TablaImpuestos" width="100%">
                                                            <tr>
                                                                <th>Impuesto</th>
                                                                <th>Tipo</th>
                                                                <th>Base</th>
                                                                <th>Tipo Factor</th>
                                                                <th>Tasa o Cuota</th>
                                                                <th>Importe</th>
                                                            </tr>
                                                            <tr v-if="concepto['Impuesto Traslado']!=''">
                                                                <td>{{concepto["Impuesto Traslado"]}}</td>
                                                                <td>Traslado</td>
                                                                <td>{{formatNumber(concepto["Subtotal"],2)}}</td>
                                                                <td>{{concepto["Tipo Factor Traslado"]}}</td>
                                                                <td>{{ concepto["TasaOCuota Traslado"]>0 ? formatNumber(concepto["TasaOCuota Traslado"]*100,4):concepto["TasaOCuota Traslado"]}}%</td>
                                                                <td style="text-align:right !important;">{{formatNumber(concepto["Importe Traslado"],2)}}</td>
                                                            </tr>
                                                            <tr v-if="concepto['Impuesto Retencion']!=''">
                                                                <td>{{concepto["Impuesto Retencion"]}}</td>
                                                                <td>Retencion</td>
                                                                <td>{{formatNumber(concepto["Subtotal"],2)}}</td>
                                                                <td>{{concepto["Tipo Factor Retencion"]}}</td>
                                                                <td>{{ concepto["TasaOCuota Retencion"]>0 ? formatNumber(concepto["TasaOCuota Retencion"]*100,4):concepto["TasaOCuota Retencion"]}}%</td>
                                                                <td style="text-align:right !important;">{{formatNumber(concepto["Importe Retencion"],2)}}</td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </template>

                                        </table>
                                        <br>
                                        <table id="tablaSubtotales" width="100%">
                                            <tr>
                                                <td width="51%">
                                                    <table width="100%">
                                                        <tr>
                                                            <th width="30%">Moneda:</th>
                                                            <td width="70%">{{model_proforma.Moneda}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Forma de pago:</th>
                                                            <td>{{model_proforma["Forma Pago"]}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Método de pago:</th>
                                                            <td>{{model_proforma["Metodo Pago"]}}</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                                <td width="1%"></td>
                                                <td width="48%">
                                                    <table width="100%">
                                                        <tr>
                                                            <th width="40%">Subtotal:</th>
                                                            <td width="10%">&nbsp;</td>
                                                            <td width="15%">&nbsp;</td>
                                                            <td width="35%" style="text-align:right !important;">$ {{formatNumber(model_proforma["SumatoriaSubtotal"],2)}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Impuestos trasladados</th>
                                                            <td>{{model_proforma["NombreImpuestoTraslado"]}}</td>
                                                            <td style="text-align:right !important;">{{ model_proforma["TasaImpuestoTraslado"]>0 ? formatNumber(model_proforma["TasaImpuestoTraslado"]*100,4):model_proforma["TasaImpuestoTraslado"]}}%</td>
                                                            <td style="text-align:right !important;">$ {{formatNumber(model_proforma["Total Impuestos Trasladado"],2)}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Impuestos Retenido</th>
                                                            <td>{{model_proforma["NombreImpuestoRetenido"]}}</td>
                                                            <td></td>
                                                            <td style="text-align:right !important;">$ {{formatNumber(model_proforma["Total Impuestos Retenidos"],2)}}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Total</th>
                                                            <td>&nbsp;</td>
                                                            <td>&nbsp;</td>
                                                            <td style="font-weight:bold;text-align:right !important;">$ {{formatNumber(model_proforma["Total Facturado"],2)}}</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                        <br>
                                            <a :href="model_proforma.QRText" target="_blank" ><v-img v-if="qrSrc" :src="qrSrc" aspect-ratio="2" width="150px" height="150px" ></v-img></a>
                                        <br/>
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-container>

            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modalProforma=false">
                    <v-icon>cancel</v-icon>&nbsp;Cerrar
                </v-btn>
                <v-btn :loading="loadingBtn" color="success" @click.native="descargarFacturaProforma()">
                    <v-icon>picture_as_pdf</v-icon>&nbsp;Descargar PDF
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import axios from "axios";
import html2pdf from "html2pdf.js";
import moment from "moment";
import qrCode from 'qrcode';
import RefreshButton from "@/components/RefreshButton.vue";

export default {
    computed: {
        datafiltered() {
            if (this.$refs['vuetabledetalle'] != null)
                return this.$refs.vuetabledetalle.allFilteredData;
            else
                return [];
        },
    },
    components: {
        "v-refresh-button": RefreshButton,
    },
    created: function () {
        this.URL = this.$hostname + "reportes/";
        this.loading = false;
        this.model.usuario = this.$local_storage.get("id_usuario");
        this.model.rfc = this.$local_storage.get("rfc");
        var tipoUsuario = this.$local_storage.get("tipo_usuario");
        if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario")
            this.permisoEliminar = true;
        this.cargarReportesDS();



        var f = new Date();
         var f_de = new Date();

              f_de.setDate(f_de.getDate() + 1);



                let y_de = f_de.getFullYear();
                let m_de = f_de.getMonth() + 1;
                let d_de = f_de.getDate();

                if (m_de < 10)
                    m_de = '0' + m_de;
                if (d_de < 10)
                    d_de = '0' + d_de;

                let y = f.getFullYear();
                let m = f.getMonth() + 1;
                let d = f.getDate();


                if (m < 10)
                    m = '0' + m;
                if (d < 10)
                    d = '0' + d;


                this.model.fecha_de = y + "-" + m + "-" + d;
                this.model.fecha_a = y_de + "-" + m_de + "-" + d_de;
    },
    filters: {
        uppercase: function(value) {
            if (!value) return ''
            value = value.toString()
            return value.toUpperCase()
        },
    },
    data: () => ({
        permisoEliminar: false,
        tab: null,
        qrSrc: null,
        data_table_impo: [],
        lista_filtrada: [],
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home",
            },
            {
                text: "eCosting",
                disabled: true,
                to: ""
            },
            {
                text: "Pedimentos - UUID",
                disabled: true,
                to: "",
            },
        ],

        update: false,

        file: "",
        cliente: "",
        name_file: "",
        size_file: 0,
        type_file: 'application/zip',
        loadingBtn:false,
        modalProforma: false,
        model_proforma: {
            transportista:'',
            hbl:'',
            contenedor:'',
            facturas:'',
            agente_carga:'',
        },

        to_download: [],
        dialog1: false,
        dialog2: false,
        listado: "",
        datos: [],
        allChecked: false,
        columns: [
            // "id",
            "fecha_solicitud",
            "usuario_email",
            "nombre_reporte",
            "criterio",
            "fecha_generacion",
            "estatus",
            "error",
            "actions",
        ],
        options: {
            filterable: [
                //   "id",
                "fecha_solicitud",
                "usuario_email",
                "nombre_reporte",
                "criterio",
                "fecha_generacion",
                "estatus",
                "error",
            ],
            sortable: [
                //  "id",
                "fecha_solicitud",
                "usuario_email",
                "nombre_reporte",
                "criterio",
                "fecha_generacion",
                "estatus",
                "error",
            ],

            headings: {
                //    id: "No. Proceso",
                fecha_solicitud: "Solicitado",
                usuario_email: "Usuario",
                nombre_reporte: "Reporte",
                criterio: "Criterio de Búsqueda",
                fecha_generacion: "Generado",
                estatus: "Estatus",
                error: "Error",
                actions: "Descargar",
            },
        },
        loading: true,
        loadingReporte: false,
        show_loading: true,
        model: {
            rfc: "",
            usuario: "",
            pedimento: "",
            fecha_de: "",
            fecha_a: "",
            //reporte_url: "/reportes_vucem/consultar_diagnostico/",
            reporte_url: "/reportes_ws/consulta_adjuntos/",
            nombre_reporte: "Facturas en Tránsito",
            tipo: "Facturas Transito",
            tipo_reporte: "",
            archivo: "", //para buscar por nombre de adjunto
            integrado: 0
        },
        menu1: false,
        menu2: false,
        menu3: false,
        menu4: false,
        fecha_factura: false,
        tiposDocumentos: [],
        rules: {
            required: (v) => !!v || "Este campo es requerido",
            numeric: (value) => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            },
        },

        modal: false,

    }),
    methods: {
        cargarReportesDS: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.model.rfc,
                "tipo": "Facturas Abiertas Pedimento"
            };
            axios.post(this.URL + "get_reportes/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos = res.data;
                        this.datos.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
                        });
                        for (var k in this.datos) {
                            this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
                            this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
                            this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
                            this.datos[k].criterio = this.getCriterioPredeterminadosDS(this.datos[k].criterio);
                        }
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los reportes ds.",
                        footer: ""
                    });
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        getCriterioPredeterminadosDS: function (criterio) {
            try {
                if (criterio != undefined && criterio.toString().trim() != "") {
                    var params = JSON.parse(criterio);
                    if (params.tipo_reporte== undefined && params.fecha_de!=undefined ){
                        return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
                    } else if (params.tipo_reporte == 1) {
                        return "Pedimento: " + params.pedimento;
                    } else if (params.tipo_reporte == 3) {
                        return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
                    } else if (params.tipo_reporte == 4) {
                        return "Búsqueda por listado de pedimentos";
                    }
                } else {
                    return "N/A";
                }
            } catch (error) {
                console.log(error);
                return "N/A-error";
            }

        },
        createObjectUrl(err, canvas) {
            if (!err) {
                canvas.toBlob((blob) => {
                    this.qrSrc = window.URL.createObjectURL(blob)
                })
            } else {
                console.warn('generateQrCode:ERROR', err)
            }
        },

        formatNumber: function(numero, decimales){
            if (numero == undefined || numero == null || numero == "")
                return ""
            return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        },


        validaFecha: function (fecha) {
            if (fecha == "Invalid date") return "Fecha no válida.";
            else return true;
        },
        validaAnio: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, "days");
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
            }
            return true;
        },

        validaDias: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, "days");
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
                if (Math.abs(diferencia) > 365)
                    return "Periodo máximo de consulta 365 dias. Favor de verificar.";
            }
            return true;
        },


        getCriterioPredeterminados: function (criterio) {
            try {
                if (criterio != undefined && criterio.toString().trim() != "") {
                    var params = JSON.parse(criterio);

                    let c = "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;

                    if (params.lista != undefined && params.lista.length > 0) {
                        c = " Orden: ";

                        params.lista.forEach(function (item) {
                            c += item + " | ";
                            console.log(item);
                        });
                    }

                    return c;

                } else {
                    return "N/A";
                }
            } catch (error) {
                return "N/A-error";
            }

        },
        getEstatus: function (estatus) {
            var arr_estatus = [
                "Pendiente",
                "Encolado",
                "Generado Correctamente",
                "Con Errores",
            ];
            if (estatus in arr_estatus) return arr_estatus[estatus];
            else return "N/A";
        },


        download_files: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            var data = {
                rfc: this.model.rfc,
                usuario: this.model.usuario,
                pedimento: this.model.pedimento,
                fecha_de: this.model.fecha_de,
                fecha_a: this.model.fecha_a,
                lista: this.model.lista,
                reporte_url: "/reportes/facturas_abiertas_zip/",
                nombre_reporte: "Zip Facturas en Tránsito Seleccionadas",
                tipo: "Facturas Transito",
                tipo_reporte: 2,
                keys: this.to_download
            };

            if (data.pedimento == '') delete(data['pedimento']);
            if (data.archivo == '') delete(data['archivo']);
            if (data.fecha_de == '') delete(data['fecha_de']);
            if (data.fecha_a == '') delete(data['fecha_a']);
            if (data.lista == '' || data.lista == []) {
                delete(data['lista'])
            } else {
                if (data.tipo_reporte == 4) {
                    data['lista'] = this.get_array_lista(data['lista'])
                }
            }

            axios({
                    method: "post",
                    url: this.$hostname + "reportes/save_reporte/",
                    data: data
                })
                .then(response => {
                    this.to_download = [];
                    if (data.tipo_reporte == 4) {
                        this.model.lista = '';
                        this.lista_filtrada = [];
                    }
                    this.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "El reporte se está generando. Cuando esté listo recibirás una notificación",
                        footer: ""
                    });
                })
                .catch(error => {
                    let mensaje;
                    var titulo = "¡Operación no Permitida!";
                    var tipo = "error";
                    if (typeof error.response !== "undefined") {
                        mensaje = error.response.data.mensaje;
                        if (error.response.status == 406) {
                            titulo = "¡Ya existe un reporte en proceso!";
                            tipo = "info";
                        }
                    } else {
                        mensaje = "Ocurrió un error al generar el reporte";
                    }
                    this.$swal({
                        type: tipo,
                        title: titulo,
                        text: mensaje,
                        footer: ""
                    });
                }).then(() => {
                    this.cargar();
                    this.$root.$dialogLoader.hide();
                });
        },

         generar_reporte_sqs(tipo_reporte) {
            if (!this.$refs.formreporte.validate()) {
                //Alguna operación o mensaje
            } else {

                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var data = {
                    rfc: this.model.rfc,
                    usuario: this.model.usuario,
                    fecha_de: this.model.fecha_de,
                    fecha_a: this.model.fecha_a,
                    reporte_url: "/reportes/facturas_abiertas_pedimento/",
                    nombre_reporte: "Pedimentos - UUID",
                    tipo: "Facturas Abiertas Pedimento",
                    fecha_factura: this.fecha_factura

                };

                axios({
                        method: "post",
                        url: this.$hostname + "reportes/save_reporte/",
                        data: data
                    })
                    .then(response => {

                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se está generando. Cuando esté listo recibirás una notificación",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        let mensaje;
                        var titulo = "¡Operación no Permitida!";
                        var tipo = "error";
                        if (typeof error.response !== "undefined") {
                            mensaje = error.response.data.mensaje;
                            if (error.response.status == 406) {
                                titulo = "¡Ya existe un reporte en proceso!";
                                tipo = "info";
                            }
                        } else {
                            mensaje = "Ocurrió un error al generar el reporte";
                        }
                        this.$swal({
                            type: tipo,
                            title: titulo,
                            text: mensaje,
                            footer: ""
                        });
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargarReportesDS();
                    });
            }
        },
        generaReporteListado(tipoReporte) {
            if (this.$refs.formListado.validate()) {
                if (tipoReporte == "completo") {
                    this.generar_reporte_sqs(1);
                } else {
                    this.get_data_view(1);
                }
                this.dialog1 = false;
                this.dialog2 = false;
            }
        },
        parseDate(date) {
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateTime(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
        },
        clear_values() {
            this.model.pedimento = "";
            this.model.fecha_de = "";
            this.model.fecha_a = "";
            this.model.archivo = "";
            this.listado = "";
        },


        downloadReporte: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = '_blank';
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        eliminarReporte: function (idreporte) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el reporte con No. Proceso: " +
                    idreporte +
                    "?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    var datos = {
                        id_reporte: idreporte,
                    };
                    axios
                        .post(this.$hostname + "reportes/eliminar_reporte/", datos)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El reporte se eliminó correctamente",
                                footer: "",
                            });
                        })
                        .catch((error) => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                                footer: "",
                            });
                            console.log(error);
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                            this.cargarReportesDS();
                        });
                }
            });
        },




    },
};
</script>

<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: #eeeeee;
    padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;
}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
    font-size: x-small !important;
}

#pdf {
    margin-left: 20px;
    height: auto;
    width: auto;
    font-family: Arial, sans-serif;
}
#facturaProforma {
    margin-left: 20px;
    height: auto;
    width: auto;
    font-family: Arial, sans-serif;
    /* font-weight: bold;    */
    line-height : 12px;
}
#tablaGenerales >>> th, td {
    border: 0 solid white !important;
    vertical-align: top !important;
    text-align: left !important;
}
#tablaMercancias tr td > #TablaImpuestos >>> th{
    border: 0 solid white !important;
    padding-right:2px !important;
    padding-left:2px !important;
    padding-top:1px !important;
    padding-bottom:1px !important;
}
#tablaMercancias tr td > #TablaImpuestos >>> td{
    border: 0 solid white !important;
    padding-right:2px !important;
    padding-left:2px !important;
    padding-top:1px !important;
    padding-bottom:1px !important;
}
#tablaMercancias >>> td {
    font-size: 8px;
    text-align: center !important;
    border: 0.1mm solid black !important;
    padding-right:3px !important;
    padding-left:3px !important;
    padding-top:1px !important;
    padding-bottom:1px !important;
}
#tablaMercancias >>> th {
    font-size: 8px;
    border: 0.1mm solid black !important;
    padding-right:3px !important;
    padding-left:3px !important;
    padding-top:3px !important;
    padding-bottom:3px !important;
}
</style>
